import {actionGroupTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = actionGroupTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const actionGroupReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default actionGroupReducer;
